import React, { useState } from "react";
import styles from "./GuestBookingModal.module.css";

const GuestBookingModal = ({ isOpen, onClose, onGuestSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const handleClick = async () => {
    setError("");

    try {
      // Validate fields
      if (!name.trim() || !email.trim() || !phone.trim()) {
        setError("All fields are required");
        return;
      }

      // Call parent handler with guest info
      await onGuestSubmit({
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim(),
      });

      // Reset form and close modal only after successful submission
      setName("");
      setEmail("");
      setPhone("");
      onClose();
    } catch (err) {
      setError("Failed to process guest booking");
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.guestModalOverlay} onClick={onClose}>
      <div className={styles.guestModal} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          ×
        </button>
        <h2>Book As Guest</h2>
        <p>You can continue without creating an account</p>
        {error && <div className={styles.errorMessage}>{error}</div>}
        <div className={styles.guestForm}>
          <label>Name</label>
          <input
            type="text"
            placeholder="Enter Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label>Phone</label>
          <input
            type="tel"
            placeholder="Enter Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <button
            type="button"
            className={styles.sendBtn}
            onClick={handleClick}
          >
            SEND
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestBookingModal;
